import React from 'react'
import ShareIcons from './ShareIcons'
import BaseDialog from './general/BaseDialog'

const DialogShareComponent = ({ dialog, setDialog }) => {
  return (
    <BaseDialog
      dialog={dialog}
      setDialog={setDialog}
      title={'Compartilhar esta página'}
      slug={'compartilhar'}
      fullWidth={true}
      maxWidth={'xs'}
    >
      <ShareIcons size='3x' justify='center' mobileXs />
    </BaseDialog>
  )
}

export default DialogShareComponent
